/**
 * Light Day — halves count habit targets for a single day.
 *
 * Stored as setting key `lightDay:YYYY-MM-DD` with value `"true"`.
 * Boolean habits are unaffected. Meeting the halved target counts as
 * a full "complete" for scoring and streaks.
 */

import type { HabitType } from "../db/schema";

/**
 * Check if a given date is a light day from raw settings rows.
 *
 * @param date - YYYY-MM-DD
 * @param settingsMap - Map of setting key → value
 */
export function isLightDay(date: string, settingsMap: ReadonlyMap<string, string>): boolean {
  return settingsMap.get(`lightDay:${date}`) === "true";
}

/**
 * Get the effective target for a habit, accounting for light day.
 *
 * Boolean habits always return 1.
 * Count habits return Math.ceil(target / 2) on light days.
 *
 * @param lightDay - Whether the day is a light day (pre-computed)
 */
export function getEffectiveTarget(
  habitType: HabitType,
  targetCount: number,
  lightDay: boolean,
): number {
  if (habitType === "boolean") return 1;
  if (lightDay) return Math.ceil(targetCount / 2);
  return targetCount;
}
